import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import FbImageLibrary from '../../../FbImageLibrary'

import ExampleAvatar from '../../../../assets/img/example/story.svg'
import Like from '../../../../assets/img/socials/additional-icons/instagram-like.svg'
import Chat from '../../../../assets/img/socials/additional-icons/instagram-chat.svg'
import Send from '../../../../assets/img/socials/additional-icons/instagram-send.svg'
import Ellipsis from '../../../UI/Icons/Ellipsis'
import Label from '../../../UI/Icons/Label'
import MessageFieldWithExtra from '../../PostEditor/UI/MessageField'

import {
    createEmptyAttachment,
    createEmptyPostSocialsBySelectedSocials,
    IManagePostState,
    TLatestSchedule,
    TPostSocialManagePost
} from '../../../../store/managePost/newTypes'
import {ATTACHMENT_TYPE, POST_SOCIAL_STATUS, POST_TYPE, SOCIAL_NETWORK, TPost} from '../../../../models/post'

import './InstagramPreview.scss'
import {TSocialDetails} from '../../../../selectors/ProjectSelector'
import VideoPreview from '../../../UI/VideoPreview'
import LoadableImage from '../../../UI/LoadableImage'
import UploadMultiContent from '../../../UploadMultiContent'
import {TMediaCallbacks} from '../../../../pages/CreatePost'
import {IMAGE_GRID_TYPE, TGridImage} from '../../../FbImageLibrary/components/Images'
import {format, isAfter} from 'date-fns'
import {useSelector} from '../../../../store'
import {getPostFromMamagePost} from '../../../../selectors/PostSelector'
import {TLatestPost, TOriginalIntagramPost} from "../../../../store/gridView/types";

interface FacebookPreviewProps {
    isMokup?: boolean
    socialPost: TPostSocialManagePost
    isMobile?: boolean
    restrictions: any
    socialDetails: TSocialDetails
    publishDate: string,
    isGrid?: boolean
    latestSchedule: TLatestSchedule,
    posts: TLatestPost[],
    post?:any
    isStory?:any
    isReels?: any
}


type TMinimumPostToRender = {
    latest_schedule: TLatestSchedule
    post_socials: TPostSocialManagePost[]
    isMokup: boolean
    id: number
}

const transformInstaPostToOriginal = (post: TOriginalIntagramPost): TMinimumPostToRender => {
    const postSocials = createEmptyPostSocialsBySelectedSocials(
        [SOCIAL_NETWORK.INSTAGRAM_SOCIAL],
        POST_TYPE.POST_TYPE_SINGLE_PHOTO
    )
    const pathToMedia = post.thumbnail_url ? post.thumbnail_url : post.media_url
    const postSocialsWithAttachment = postSocials.map((socialPost) => ({
        ...socialPost,
        attachments: [createEmptyAttachment(pathToMedia)]
    }))

    const dateWithoutTimezone = post.created_at.split('+')[0]
    const date = new Date(dateWithoutTimezone)

    return {
        post_socials: postSocialsWithAttachment,
        latest_schedule: {
            id: 0,
            is_autoposting: false,
            timezone: '',
            date: format(date, 'yyyy-MM-dd'),
            time: format(date, 'hh:mm'),
            datetime: ''
        },
        id: 0,
        isMokup: true
    }
}


const InstagramPreview: FC<FacebookPreviewProps> = ({
                                                        isMokup,
                                                        isMobile = false,
                                                        restrictions,
                                                        publishDate,
                                                        socialPost,
                                                        socialDetails,
                                                        isGrid,
                                                        latestSchedule,
                                                        posts,
                                                        post,
                                                        isStory,
                                                        isReels
                                                    }) => {
    const mockRefMediaCallbaks = useRef<TMediaCallbacks>({
        addImage: () => {
        },
        addVideo: () => {
        },
        startEditLink: () => {
        },
        addChildLink: () => {
        },
        addCanvaImage: () => {
        }
    })


    const getPostData = useSelector((state) => ({
        currentPost: getPostFromMamagePost(state)
    }))

    const currentPost = post ? post: getPostData.currentPost


    const socialData = useMemo(() => socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL], [])

    const latestPostsWithNewOne = useMemo(() => {
        const postsCopy = posts.map(({post, instagramMedia}) =>
            post ? post : transformInstaPostToOriginal(instagramMedia!)
        )
        const postIndex = postsCopy.findIndex(
            (post) => !(post as any).isMokup && post.id === currentPost.id
        )

        if (!!currentPost.id && postIndex !== -1) {
            postsCopy.splice(postIndex, 1, currentPost)
        } else {
            postsCopy.unshift(currentPost)
        }

        return postsCopy.sort((postA, postB) => {
            const {date: postDateA, time: postTimeA} = postA.latest_schedule
            const {date: postDateB, time: postTimeB} = postB.latest_schedule

            return isAfter(new Date(`${postDateA}T${postTimeA}`), new Date(`${postDateB}T${postTimeB}`))
                ? -1
                : 1
        })
    }, [currentPost, posts])

    const instaGridImages = useMemo(() => {
        let gridImages: TGridImage[] = []

        latestPostsWithNewOne.forEach((post) => {
            let mediaDataToGrid

            for (let socialPost of post.post_socials) {
                if (socialPost.social_network === SOCIAL_NETWORK.INSTAGRAM_SOCIAL) {
                    mediaDataToGrid = socialPost.attachments[0]?.object_data
                    break
                }
            }
            //debugger;
            const {date, time, is_autoposting} = post.latest_schedule
            const socialPost = post.post_socials.find(
                (post) => post.social_network === SOCIAL_NETWORK.INSTAGRAM_SOCIAL
            )!

            if (mediaDataToGrid?.public_url) {
                let public_url = mediaDataToGrid.public_url

                if (mediaDataToGrid.options.type === ATTACHMENT_TYPE.TYPE_VIDEO) {
                    const videoPreviews = mediaDataToGrid.previews
                    public_url =
                        videoPreviews?.original || videoPreviews?.medium || videoPreviews?.small || ''
                }

                gridImages.push({
                    ...mediaDataToGrid,
                    public_url,
                    dateData: {
                        date: format(new Date(`${date}T${time}`), 'dd MMM yyyy KK:mm aa'),
                        isAutoposting: is_autoposting,
                        status: socialPost.status || POST_SOCIAL_STATUS.STATUS_DRAFT,
                        isMokup: !!(post as any).isMokup
                    }
                })
            } else {
                let d;
                if (date) {
                    d = new Date(`${date}T${time}`);
                } else {
                    d = new Date()
                }
 /*               gridImages.push({
                    content_type: '',
                    file_path: '',
                    file_size: 0,
                    id: 0,
                    options: {
                        height: 0,
                        ratio: '',
                        type: ATTACHMENT_TYPE.TYPE_IMAGE,
                        width: 0
                    },
                    is_temporary: true,
                    media_collection_type: '',
                    parent_media_id: 0,
                    original_name: '',
                    public_url: '',
                    user_id: 0,
                    canva_design_id: null,
                    dateData: {
                        date: format(d, 'dd MMM yyyy KK:mm aa'),
                        isAutoposting: is_autoposting,
                        status: socialPost?.status || POST_SOCIAL_STATUS.STATUS_DRAFT,
                        isMokup: !!(post as any).isMokup
                    }
                })*/
            }
        })

        return gridImages
    }, [latestPostsWithNewOne])

    const [ checkIsImage, setCheckIsImage ] = useState('')
    useEffect(() => {
        if(socialPost.attachments.length > 0 && (socialPost.type === POST_TYPE.POST_TYPE_REELS || socialPost.type === POST_TYPE.POST_TYPE_VIDEO_STORY)){
            setCheckIsImage('hasMedia typeVideo')
        } else if(socialPost.attachments.length > 0 && socialPost.type === POST_TYPE.POST_TYPE_PHOTO_STORY){
            setCheckIsImage('hasMedia')
        } else {
            setCheckIsImage('')
        }
    }, [socialPost])

    return (
        <div
            className={`post-preview instagram-preview ${((isStory || isReels) && checkIsImage !== '') && checkIsImage} ${isMokup && 'mokup'} ${isMobile && 'mobile-view'
            }`}
        >
            { (isStory || isReels) ? 
                <div className='instagram-story-reels'>
                    <div className='instagram-customer'>
                        <div className='instagram-customer__story'>
                            <div className='instagram-customer__story__name'>{ isStory ? 'Stories' : 'Reels' }</div>
                        </div>
                        <div className='instagram-customer__etcs'>
                            <div className="three-vertical-dots"></div>
                        </div>
                    </div>
                </div>
                :
                <div className='instagram-customer'>
                    <div className='instagram-customer__avatar'>
                        {socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL].logo.original ? (
                            <LoadableImage media={socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL].logo.original!}/>
                        ) : (
                            socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL]!.logo.default
                        )}
                    </div>
                    <div className='instagram-customer__data'>
                        <div className='instagram-customer__data__name'>
                            {socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL]!.name}
                        </div>
                    </div>
                    <div className='instagram-customer__etc'>
                        <Ellipsis/>
                    </div>
                </div>
            }
            {isGrid&&instaGridImages.length>0 ? <div className='instagram-grid-previews'>
                <FbImageLibrary
                    hideOverlay={true}
                    isEditable={false}
                    countFrom={9}
                    gridType={IMAGE_GRID_TYPE.INSTA_GRID}
                    images={instaGridImages} // object_data
                />
            </div> : (restrictions.mediaRestrictions.image || restrictions.mediaRestrictions.video) && !!socialPost.attachments.length && (
                <div className='instagram-multi-content'>
                    <UploadMultiContent {
                                            ...{
                                                attachments: socialPost.attachments,
                                                addMediaToPost: () => {
                                                },
                                                refMediaCallbaks: mockRefMediaCallbaks,
                                                restrictions,
                                                isPreview: true,
                                                isMokup,
                                                removeMediaFromStore: () => {
                                                },
                                                isEditable: false
                                            }} />
                </div>
            )}
            { !(isStory || isReels || isGrid) &&  
                <>
                    <div className='instagram-assessments'>
                        <div className='instagram-assessments__motion-wrapper'>
                            <div className='instagram-assessments__motion-wrapper__icon'>
                                <img src={Like} alt='any'/>
                            </div>
                            <div className='instagram-assessments__motion-wrapper__icon'>
                                <img src={Chat} alt='any'/>
                            </div>
                            <div className='instagram-assessments__motion-wrapper__icon'>
                                <img src={Send} alt='any'/>
                            </div>
                        </div>

                        <div className='instagram-assessments__label-wrapper'>
                            <Label/>
                        </div>
                    </div>
                    <div className='instagram-text__name'>
                        {socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL]!.name}
                    </div>
                </>
            }
            {(socialPost.message && !isGrid && !isReels) && (
                <div className='instagram-text'>
                    <MessageFieldWithExtra
                        {...{
                            social: socialPost.social_network,
                            editorRaws: socialPost.message_editor_state,
                            value: socialPost.message
                        }}
                    />
                </div>
            )}
            { !(isStory || isReels || isGrid) &&  
                <div className='instagram-text__publish-date'>{publishDate}</div>
            }
            {socialPost && socialPost?.first_comment && !isReels ? <div className='instagram-first-comments'>
                <div className='title'>First Comments</div>
                <div className='value'>{socialPost.first_comment}
                </div>
            </div> : null}
        </div>
    )
}

export default InstagramPreview
